import http from "@/core/global/http"
import type {
  IPatientReportResponse,
  IPatientCaseReportResponse,
} from "@/modules/Patient/Overview/components/patientReportTables/patient-report.types"

export const getPatientReport = async (
  orgId: string,
  patientId: string,
): Promise<IPatientReportResponse | null> => {
  const { data } = await http.get(
    `/patient-mgmt/v3/org/${orgId}/patients/${patientId}/report`,
  )
  const result = data.result
  if (!result || Array.isArray(result)) return null
  return result
}

export const getPatientCaseReport = async (
  orgId: string,
  patientId: string,
  caseId: string,
): Promise<IPatientCaseReportResponse | null> => {
  const { data } = await http.get(
    `/patient-mgmt/v3/org/${orgId}/patients/${patientId}/report`,
    { params: { case_id: caseId } },
  )
  const result = data.result
  if (!result || Array.isArray(result)) return null
  return result
}
